
import Vue from 'vue';
import axios from '@/plugins/axios.js';
import { Provide, Component, Prop, Ref } from 'vue-property-decorator';
@Component
export default class InputExpress extends Vue {
    @Prop() private channels!: { [index: string]: string };
    @Provide() private showDialog: boolean = false;
    @Provide() private expressInfo: any = {
        content: '',
        channel: '',
        number: '',
    };
    @Provide() private rules: { [index: string]: object[] } = {
        content: [
            { required: true, message: '请输入寄件内容', trigger: 'blur' },
        ],
        channel: [
            { required: true, message: '请选择物流公司', trigger: 'change' },
        ],
        number: [
            { required: true, message: '请填写快递单号', trigger: 'blur' },
        ],
    };
    @Ref() private readonly expressForm;
    @Prop() private selectedExpress!: any;

    private created() {
        this.$on('open', () => {
            this.showDialog = true;
        });
    }

    private clearValidate() {
        this.expressForm.clearValidate();
    }

    private submit() {
        this.expressForm.validate((valid) => {
            if (!valid) {
                return false;
            } else {
                const url = '/api/v1/express/create-record';
                const params = {
                    content: this.expressInfo.content,
                    uuid: this.selectedExpress.uuid,
                    channel: this.expressInfo.channel,
                    express_number: this.expressInfo.number,
                };
                axios.post(url, params).then(() => {
                    this.$message({
                        type: 'success',
                        message: '快递信息录入成功，短信与服务号通知已发出',
                    });
                    this.expressInfo.number = '';
                    this.showDialog = false;
                }).catch((error) => {
                    this.$message.error(error);
                });
            }
        });
    }

}
